import omit from "lodash/omit";

export const normalizeFormValue = (value: unknown): unknown => {
  if (typeof value === "function") return undefined;
  if (value instanceof Date) return value.toISOString();
  if (value === "" || value === null || value === undefined) return null;

  if (Array.isArray(value)) {
    return value
      .map((item) => normalizeFormValue(item))
      .filter((item) => item !== null && item !== undefined);
  }

  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value)
        .map(([key, val]) => [key, normalizeFormValue(val)])
        .filter(([, normalizedValue]) => normalizedValue !== undefined),
    );
  }

  return value;
};

// used to compare form values with empty values to determine if there any changes
export const hasFormData = (
  values: unknown,
  emptyValues: unknown,
  fieldsToOmit: string[] = [],
): boolean => {
  const normalizedValues = normalizeFormValue(values);
  const normalizedEmptyValues = normalizeFormValue(emptyValues);

  const comparableValues =
    fieldsToOmit.length > 0 ? omit(normalizedValues as object, fieldsToOmit) : normalizedValues;
  const comparableEmptyValues =
    fieldsToOmit.length > 0
      ? omit(normalizedEmptyValues as object, fieldsToOmit)
      : normalizedEmptyValues;

  return JSON.stringify(comparableValues) !== JSON.stringify(comparableEmptyValues);
};
